<template>
    <div>
      <div style="display: flex; justify-content: space-between;">
        <div class="stat-bemor-text">
          <b-button
            variant="primary"
            class="navbarBtnTashxis mb-3 mr-2"
            v-b-modal="'modal-shablon' + 'shifokor_tash' + index + modalIdCom"
            @click="getShablonDoctor('shifokor_tash', {tppe: false})"
          >
            <b-icon icon="arrow-down-circle-fill"></b-icon>
          </b-button>
  
          <b-button
            variant="primary"
            class="navbarBtnTashxis mb-3"
            @click="status = 'shifokor_tash',row_click_type =  { type: false}"
            v-b-modal="'modal-new-shab-creat-shifokor_tash' + index + modalIdCom"
          >
            <b-icon icon="arrow-up-circle-fill"></b-icon>
          </b-button>
          <b-modal
            :id="'modal-shablon' + 'shifokor_tash' + index + modalIdCom"
            size="lg"
            :title="$t('Шаблонлар рўйхати')"
            hide-footer
          >
            <Shablon
              :modalIdCom="modalIdCom"
              :plus_dont_show="true"
              :shabType="'shifokor_tash'"
              :itemsShablon="itemsShablon"
              @ShablonGet="getShablon"
              @RowClickedShab="RowClickedShab"
            />
          </b-modal>
          <b-modal
            :id="'modal-new-shab-creat-shifokor_tash' + index + modalIdCom"
            :title="$t('Шифокор шаблон')"
            
            hide-footer
          >
            <div>
              <b-input type="text" v-model="name"></b-input>
            </div>
            <div class="CreateName">
              <b-button
                class="modalBtn1"
                size="sm"
                style="height: 37px;"
                variant="danger "
                @click="ShifokorShablonClose"
              >
                <b-icon icon="calendar2-x"></b-icon>
                {{ $t("Бекор қилиш") }}
              </b-button>
              <b-button
                class="mt-3 ml-2 modalBtn"
                @click="ShifokorShablon"
                variant="success"
              >
                <b-icon icon="calendar2-plus"></b-icon>
                {{ $t("Сақлаш") }}
              </b-button>
            </div>
          </b-modal>
          <br>
          <h3 class="sarlovha-style">
            Ambulator tibbiy karta №
            <input
              type="number"
              @input="textChange"
              class="input-stile"
              style="font-size: 35px; font-weight: 600; width: 170px; margin-bottom: 5px;"
              v-model="selectShablonJson.value0"
            />
          </h3>
          <label>Ish (o'qish) joyi:</label>
          <div>
            <input
              type="text"
              @input="textChange"
              @focus="showDiv($event, 'value43', 'karta_value43')"
              @blur="handleBlur($event)"
              class="input-stile"
              style="width: 500px;"
              v-model="selectShablonJson.value43"
            />
          </div>
            <br>
          <label>Ro'yxatdan chiqish sababi ko'rsatilsin</label>
          <input
              type="text"
              @input="textChange"
              @focus="showDiv($event, 'value44', 'karta_value44')"
              @blur="handleBlur($event)"
              class="input-stile"
              style="width: 500px;"
              v-model="selectShablonJson.value44"
            />
            <br>
            <label>Dispanserizatsiya</label>
          <input
              type="text"
              @input="textChange"
              @focus="showDiv($event, 'value45', 'karta_value45')"
              @blur="handleBlur($event)"
              class="input-stile"
              style="width: 500px;"
              v-model="selectShablonJson.valu45"
            />
            <br>
            <label>Aynan shu muassasada</label>
          <input
              type="text"
              @input="textChange"
              @focus="showDiv($event, 'value46', 'karta_value46')"
              @blur="handleBlur($event)"
              class="input-stile"
              style="width: 500px;"
              v-model="selectShablonJson.value46"
            />
            <br>
            <label>Boshqa muassasada</label>
          <input
              type="text"
              @input="textChange"
              @focus="showDiv($event, 'value47', 'karta_value47')"
              @blur="handleBlur($event)"
              class="input-stile"
              style="width: 500px;"
              v-model="selectShablonJson.value47"
            />
            <h3 class="sarlovha-style">
            Muhim belgilar
          </h3>
          <label>Qon guruhi</label>
          <input
              type="text"
              @input="textChange"
              class="input-stile"
              style="width: 200px;"
              v-model="selectShablonJson.value48"
            />
            <label>Rezus mansublik</label>
            <input
              type="text"
              @input="textChange"
              @focus="showDiv($event, 'value49', 'karta_value49')"
              @blur="handleBlur($event)"
              class="input-stile"
              style="width: 200px;"
              v-model="selectShablonJson.value49"
            />
            <br>
          <label>Bemorning shikoyati:</label>
          <b-button
            variant="primary"
            class="navbarBtnTashxis mb-3 mr-2"
            v-b-modal="'modal-shablon' + 'shifokor_tash' + index + modalIdCom"
            @click="getShablonDoctor('karta_value1', {type: true, value: 'value1'})"
          >
            <b-icon icon="arrow-down-circle-fill"></b-icon>
          </b-button>
  
          <b-button
            variant="primary"
            class="navbarBtnTashxis mb-3"
            @click="status = 'karta_value1', row_click_type =  { type: true, value: 'value1'}"
            v-b-modal="'modal-new-shab-creat-shifokor_tash' + index + modalIdCom"
          >
            <b-icon icon="arrow-up-circle-fill"></b-icon>
          </b-button>
          <textarea
            v-model="selectShablonJson.value1"
            max-rows="10"
            @input="textChange"
            style="width: 100%;"
            class="input-stile-textarea"
            type="textari"
          ></textarea>
          <label>Anamnesis morbi (ushbu kasallik tarixi):</label>
          <b-button
            variant="primary"
            class="navbarBtnTashxis mb-3 mr-2"
            v-b-modal="'modal-shablon' + 'shifokor_tash' + index + modalIdCom"
            @click="getShablonDoctor('karta_value2', {type: true, value: 'value2'})"
          >
            <b-icon icon="arrow-down-circle-fill"></b-icon>
          </b-button>
  
          <b-button
            variant="primary"
            class="navbarBtnTashxis mb-3"
            @click="status = 'karta_value2', row_click_type =  { type: true, value: 'value2'}"
            v-b-modal="'modal-new-shab-creat-shifokor_tash' + index + modalIdCom"
          >
            <b-icon icon="arrow-up-circle-fill"></b-icon>
          </b-button>
          <textarea
            max-rows="10"
            style="width: 100%;"
            v-model="selectShablonJson.value2"
            class="input-stile-textarea"
            @input="textChange"
          ></textarea>
          <label>Anamnesis vitae (bemorning kechirgan kasalliklari):</label>
          <b-button
            variant="primary"
            class="navbarBtnTashxis mb-3 mr-2"
            v-b-modal="'modal-shablon' + 'shifokor_tash' + index + modalIdCom"
            @click="getShablonDoctor('karta_value35', {type: true, value: 'value35'})"
          >
            <b-icon icon="arrow-down-circle-fill"></b-icon>
          </b-button>
  
          <b-button
            variant="primary"
            class="navbarBtnTashxis mb-3"
            @click="status = 'karta_value35', row_click_type =  { type: true, value: 'value35'}"
            v-b-modal="'modal-new-shab-creat-shifokor_tash' + index + modalIdCom"
          >
            <b-icon icon="arrow-up-circle-fill"></b-icon>
          </b-button>
          <textarea
            max-rows="10"
            style="width: 100%;"
            v-model="selectShablonJson.value35"
            class="input-stile-textarea"
            @input="textChange"
          ></textarea>
          <div>
            <h3 class="sarlovha-style">Epidemiologik anamnez</h3>
          </div>
          <div class="display-flex">
            <input
              type="text"
              @input="textChange"
              @focus="showDiv($event, 'value3', 'tek_value3')"
              @blur="handleBlur($event)"
              class="input-stile"
              style="width: 300px;"
              v-model="selectShablonJson.value3"
            />
            <label>yuqumli kasalliklar</label>
            <input
              type="text"
              @input="textChange"
              @focus="showDiv($event, 'value4', 'tek_value4')"
              @blur="handleBlur($event)"
              class="input-stile"
              style="width: 300px;"
              v-model="selectShablonJson.value4"
            />
          </div>
          <label>bilan og'rigan bemorlar (kasallik inkubatsion davrini hisobga olgan holda) bilan muomalada bo'lganmi.</label>
          <div
              @click="selectKey('tek_value7'), (row_click_type = {type: true, value: 'value79'})"
              style="width: 200px;"
            >
              <v-select
                style="width: 100%;"
                :options="itemShablon"
                ref="doriselect"
                label="name"
                v-model="selectShablonJson.value79"
                @search="ValueSel"
                @input="textChange"
                :reduce="options => options.name"
                @keydown.native="setStatus($event)"
              >
                <template #search="{ attributes, events }">
                  <input class="vs__search" v-bind="attributes" v-on="events" />
                  <button
                    v-if="!selectShablonJson.value79"
                    class="btn-select"
                    v-b-modal="'shablon-select-karta' + index + modalIdCom"
                  >
                    ...
                  </button>
                </template>
                <template
                  v-slot:no-options="{
                    search,
                    searching
                  }"
                >
                  <template v-if="searching">
                    <em
                      ><b>{{ search }}</b></em
                    >{{ "бўйича маьлумот йўқ" }}
                    <div class="d-flex-center">
                      <b-button
                        class="insertbtn"
                        variant="success"
                        @click="setStatus(45)"
                        v-b-modal="'modal-shab-select-create-karta-doc' + index + modalIdCom"
                      >
                        <b-icon icon="plus" color="#fff"></b-icon>
                      </b-button>
                    </div>
                    <b> Insert</b>
                  </template>
                  <em style="opacity: 0.5;" v-else>{{ "Маьлумот йўқ" }}</em>
                </template>
              </v-select>
            </div>
          <div>
            <label>Muloqotda bo'lgan vaqti:</label>
            <input 
              style="width: calc(100% - 500px);"
              type="text"
              @input="textChange"
              class="input-stile"
              v-model="selectShablonJson.value5"
            >
            <label>dan</label>
            <input 
              style="width: 150px;"
              type="text"
              @input="textChange"
              class="input-stile"
              v-model="selectShablonJson.value6"
            >
            <label>gacha</label>
          </div>
          <div>
            <label>Haqiqiy kasallik boshlanishidan 1-hafta - 2 oy avval axoli yashash joyidan chetda bo'lganmi</label>
          </div>
          <div class="display-flex">
            <div
              @click="selectKey('tek_value7'), (row_click_type = {type: true, value: 'value7'})"
              style="width: 130px; margin-right: 10px;"
            >
              <v-select
                style="width: 100%;"
                :options="itemShablon"
                ref="doriselect"
                label="name"
                v-model="selectShablonJson.value7"
                @search="ValueSel"
                @input="textChange"
                :reduce="options => options.name"
                @keydown.native="setStatus($event)"
              >
                <template #search="{ attributes, events }">
                  <input class="vs__search" v-bind="attributes" v-on="events" />
                  <button
                    v-if="!selectShablonJson.value7"
                    class="btn-select"
                    v-b-modal="'shablon-select-karta' + index + modalIdCom"
                  >
                    ...
                  </button>
                </template>
                <template
                  v-slot:no-options="{
                    search,
                    searching
                  }"
                >
                  <template v-if="searching">
                    <em
                      ><b>{{ search }}</b></em
                    >{{ "бўйича маьлумот йўқ" }}
                    <div class="d-flex-center">
                      <b-button
                        class="insertbtn"
                        variant="success"
                        @click="setStatus(45)"
                        v-b-modal="'modal-shab-select-create-karta-doc' + index + modalIdCom"
                      >
                        <b-icon icon="plus" color="#fff"></b-icon>
                      </b-button>
                    </div>
                    <b> Insert</b>
                  </template>
                  <em style="opacity: 0.5;" v-else>{{ "Маьлумот йўқ" }}</em>
                </template>
              </v-select>
            </div>
            <div
              @click="selectKey('tek_value8'), (row_click_type = {type: true, value: 'value8'})"
              style="width: 450px"
            >
              <v-select
                style="width: 100%;"
                :options="itemShablon"
                ref="doriselect"
                label="name"
                v-model="selectShablonJson.value8"
                @search="ValueSel"
                @input="textChange"
                :reduce="options => options.name"
                @keydown.native="setStatus($event)"
              >
                <template #search="{ attributes, events }">
                  <input class="vs__search" v-bind="attributes" v-on="events" />
                  <button
                    v-if="!selectShablonJson.value8"
                    class="btn-select"
                    v-b-modal="'shablon-select-karta' + index + modalIdCom"
                  >
                    ...
                  </button>
                </template>
                <template
                  v-slot:no-options="{
                    search,
                    searching
                  }"
                >
                  <template v-if="searching">
                    <em
                      ><b>{{ search }}</b></em
                    >{{ "бўйича маьлумот йўқ" }}
                    <div class="d-flex-center">
                      <b-button
                        class="insertbtn"
                        variant="success"
                        @click="setStatus(45)"
                        v-b-modal="'modal-shab-select-create-karta-doc' + index + modalIdCom"
                      >
                        <b-icon icon="plus" color="#fff"></b-icon>
                      </b-button>
                    </div>
                    <b> Insert</b>
                  </template>
                  <em style="opacity: 0.5;" v-else>{{ "Маьлумот йўқ" }}</em>
                </template>
              </v-select>
              <div class="izoh-style">qayerda bo'lgan va qachon qaytib kelgan</div>
            </div>
          </div>
          <div class="display-flex">
            <label>Qanday yuqumli kasalliklar bilan og'rigan?</label>
            <input
              type="text"
              @input="textChange"
              @focus="showDiv($event, 'value9', 'tek_value9')"
              @blur="handleBlur($event)"
              class="input-stile"
              style="width: 400px;"
              v-model="selectShablonJson.value9"
            />
          </div>
          <div class="sarlovha">So'ngi 6 oy ichida:</div>
          <div class="display-flex">
            <label>Statsionar yoki ambulator davolanishda bo'lganimi?</label>
            <div
              @click="selectKey('tek_value7'), (row_click_type = {type: true, value: 'value10'})"
              style="width: 130px"
            >
              <v-select
                style="width: 100%;"
                :options="itemShablon"
                ref="doriselect"
                label="name"
                v-model="selectShablonJson.value10"
                @search="ValueSel"
                @input="textChange"
                :reduce="options => options.name"
                @keydown.native="setStatus($event)"
              >
                <template #search="{ attributes, events }">
                  <input class="vs__search" v-bind="attributes" v-on="events" />
                  <button
                    v-if="!selectShablonJson.value10"
                    class="btn-select"
                    v-b-modal="'shablon-select-karta' + index + modalIdCom"
                  >
                    ...
                  </button>
                </template>
                <template
                  v-slot:no-options="{
                    search,
                    searching
                  }"
                >
                  <template v-if="searching">
                    <em
                      ><b>{{ search }}</b></em
                    >{{ "бўйича маьлумот йўқ" }}
                    <div class="d-flex-center">
                      <b-button
                        class="insertbtn"
                        variant="success"
                        @click="setStatus(45)"
                        v-b-modal="'modal-shab-select-create-karta-doc' + index + modalIdCom"
                      >
                        <b-icon icon="plus" color="#fff"></b-icon>
                      </b-button>
                    </div>
                    <b> Insert</b>
                  </template>
                  <em style="opacity: 0.5;" v-else>{{ "Маьлумот йўқ" }}</em>
                </template>
              </v-select>
            </div>
          </div>
          <div class="display-flex">
            <label>Gemotransfuziya (Qon va uning komponentlari) o'tkazilganmi?</label>
            <div
              @click="selectKey('tek_value7'), (row_click_type = {type: true, value: 'value11'})"
              style="width: 130px"
            >
              <v-select
                style="width: 100%;"
                :options="itemShablon"
                ref="doriselect"
                label="name"
                v-model="selectShablonJson.value11"
                @search="ValueSel"
                @input="textChange"
                :reduce="options => options.name"
                @keydown.native="setStatus($event)"
              >
                <template #search="{ attributes, events }">
                  <input class="vs__search" v-bind="attributes" v-on="events" />
                  <button
                    v-if="!selectShablonJson.value11"
                    class="btn-select"
                    v-b-modal="'shablon-select-karta' + index + modalIdCom"
                  >
                    ...
                  </button>
                </template>
                <template
                  v-slot:no-options="{
                    search,
                    searching
                  }"
                >
                  <template v-if="searching">
                    <em
                      ><b>{{ search }}</b></em
                    >{{ "бўйича маьлумот йўқ" }}
                    <div class="d-flex-center">
                      <b-button
                        class="insertbtn"
                        variant="success"
                        @click="setStatus(45)"
                        v-b-modal="'modal-shab-select-create-karta-doc' + index + modalIdCom"
                      >
                        <b-icon icon="plus" color="#fff"></b-icon>
                      </b-button>
                    </div>
                    <b> Insert</b>
                  </template>
                  <em style="opacity: 0.5;" v-else>{{ "Маьлумот йўқ" }}</em>
                </template>
              </v-select>
            </div>
          </div>
          <div class="display-flex">
            <label>Bemorga jarrohlik muolajalari o'tkazilganmi?</label>
            <div
              @click="selectKey('tek_value7'), (row_click_type = {type: true, value: 'value12'})"
              style="width: 130px"
            >
              <v-select
                style="width: 100%;"
                :options="itemShablon"
                ref="doriselect"
                label="name"
                v-model="selectShablonJson.value12"
                @search="ValueSel"
                @input="textChange"
                :reduce="options => options.name"
                @keydown.native="setStatus($event)"
              >
                <template #search="{ attributes, events }">
                  <input class="vs__search" v-bind="attributes" v-on="events" />
                  <button
                    v-if="!selectShablonJson.value12"
                    class="btn-select"
                    v-b-modal="'shablon-select-karta' + index + modalIdCom"
                  >
                    ...
                  </button>
                </template>
                <template
                  v-slot:no-options="{
                    search,
                    searching
                  }"
                >
                  <template v-if="searching">
                    <em
                      ><b>{{ search }}</b></em
                    >{{ "бўйича маьлумот йўқ" }}
                    <div class="d-flex-center">
                      <b-button
                        class="insertbtn"
                        variant="success"
                        @click="setStatus(45)"
                        v-b-modal="'modal-shab-select-create-karta-doc' + index + modalIdCom"
                      >
                        <b-icon icon="plus" color="#fff"></b-icon>
                      </b-button>
                    </div>
                    <b> Insert</b>
                  </template>
                  <em style="opacity: 0.5;" v-else>{{ "Маьлумот йўқ" }}</em>
                </template>
              </v-select>
            </div>
          </div>
          <label>Parenteral muolajalar (jumladan, igna bilan davolash) qabul qilinganmi?</label>
          <input 
            class="input-stile" 
            style="width: 100%;"
            @input="textChange" 
            @focus="showDiv($event, 'value13', 'karta_value13')"
            @blur="handleBlur($event)"
            type="text"
            v-model="selectShablonJson.value13"
          ></input>
          <label>Maishiy xizmat turlaridan foydalanganmi (manikyur, pedikyur, tatuaj, ...)</label>
          <input 
            class="input-stile" 
            style="width: 100%;" 
            @input="textChange" 
            @focus="showDiv($event, 'value14', 'karta_value14')"
            @blur="handleBlur($event)"
            type="text"
            v-model="selectShablonJson.value14"
          ></input>
          <div class="izoh-style">Xizmat turi, joyi va vaqtini ko'rsating</div>
  
          <div class="display-flex">
            <label>Salbiy odatlari:</label>
            <div
              @click="selectKey('tek_value22'), (row_click_type = {type: true, value: 'value22'})"
              style="width: 500px"
            >
              <v-select
                style="width: 100%;"
                :options="itemShablon"
                ref="doriselect"
                label="name"
                v-model="selectShablonJson.value22"
                @search="ValueSel"
                @input="textChange"
                :reduce="options => options.name"
                @keydown.native="setStatus($event)"
              >
                <template #search="{ attributes, events }">
                  <input class="vs__search" v-bind="attributes" v-on="events" />
                  <button
                    v-if="!selectShablonJson.value22"
                    class="btn-select"
                    v-b-modal="'shablon-select-karta' + index + modalIdCom"
                  >
                    ...
                  </button>
                </template>
                <template
                  v-slot:no-options="{
                    search,
                    searching
                  }"
                >
                  <template v-if="searching">
                    <em
                      ><b>{{ search }}</b></em
                    >{{ "бўйича маьлумот йўқ" }}
                    <div class="d-flex-center">
                      <b-button
                        class="insertbtn"
                        variant="success"
                        @click="setStatus(45)"
                        v-b-modal="'modal-shab-select-create-karta-doc' + index + modalIdCom"
                      >
                        <b-icon icon="plus" color="#fff"></b-icon>
                      </b-button>
                    </div>
                    <b> Insert</b>
                  </template>
                  <em style="opacity: 0.5;" v-else>{{ "Маьлумот йўқ" }}</em>
                </template>
              </v-select>
            </div>
          </div>
          <div class="display-flex">
            <label>Alkagol ishimliklar istemoli:</label>
            <div
              @click="selectKey('tek_value23'), (row_click_type = {type: true, value: 'value23'})"
              style="width: 480px"
            >
              <v-select
                style="width: 100%;"
                :options="itemShablon"
                ref="doriselect"
                label="name"
                v-model="selectShablonJson.value23"
                @search="ValueSel"
                @input="textChange"
                :reduce="options => options.name"
                @keydown.native="setStatus($event)"
              >
                <template #search="{ attributes, events }">
                  <input class="vs__search" v-bind="attributes" v-on="events" />
                  <button
                    v-if="!selectShablonJson.value23"
                    class="btn-select"
                    v-b-modal="'shablon-select-karta' + index + modalIdCom"
                  >
                    ...
                  </button>
                </template>
                <template
                  v-slot:no-options="{
                    search,
                    searching
                  }"
                >
                  <template v-if="searching">
                    <em
                      ><b>{{ search }}</b></em
                    >{{ "бўйича маьлумот йўқ" }}
                    <div class="d-flex-center">
                      <b-button
                        class="insertbtn"
                        variant="success"
                        @click="setStatus(45)"
                        v-b-modal="'modal-shab-select-create-karta-doc' + index + modalIdCom"
                      >
                        <b-icon icon="plus" color="#fff"></b-icon>
                      </b-button>
                    </div>
                    <b> Insert</b>
                  </template>
                  <em style="opacity: 0.5;" v-else>{{ "Маьлумот йўқ" }}</em>
                </template>
              </v-select>
            </div>
          </div>
          <div class="display-flex">
            <label>Oilaviy ahvoli:</label>
            <div
              @click="selectKey('tek_value24'), (row_click_type = {type: true, value: 'value24'})"
              style="width: 500px"
            >
              <v-select
                style="width: 100%;"
                :options="itemShablon"
                ref="doriselect"
                label="name"
                v-model="selectShablonJson.value24"
                @search="ValueSel"
                @input="textChange"
                :reduce="options => options.name"
                @keydown.native="setStatus($event)"
              >
                <template #search="{ attributes, events }">
                  <input class="vs__search" v-bind="attributes" v-on="events" />
                  <button
                    v-if="!selectShablonJson.value24"
                    class="btn-select"
                    v-b-modal="'shablon-select-karta' + index + modalIdCom"
                  >
                    ...
                  </button>
                </template>
                <template
                  v-slot:no-options="{
                    search,
                    searching
                  }"
                >
                  <template v-if="searching">
                    <em
                      ><b>{{ search }}</b></em
                    >{{ "бўйича маьлумот йўқ" }}
                    <div class="d-flex-center">
                      <b-button
                        class="insertbtn"
                        variant="success"
                        @click="setStatus(45)"
                        v-b-modal="'modal-shab-select-create-karta-doc' + index + modalIdCom"
                      >
                        <b-icon icon="plus" color="#fff"></b-icon>
                      </b-button>
                    </div>
                    <b> Insert</b>
                  </template>
                  <em style="opacity: 0.5;" v-else>{{ "Маьлумот йўқ" }}</em>
                </template>
              </v-select>
            </div>
          </div>
          <label>Hayz ko'rish davri, homiladorligi</label>
          <input 
            class="input-stile" 
            style="width: 500px;" 
            @input="textChange" 
            @focus="showDiv($event, 'value16', 'karta_value16')"
            @blur="handleBlur($event)"
            type="text"
            v-model="selectShablonJson.value16"
          ></input>
          <div class="display-flex">
            <label>Oxirgi 6 oy ichida qabul qilgan muolajalari:</label>
            <input 
              class="input-stile mb-2" 
              style="width: 500px;" 
              @input="textChange" 
              @focus="showDiv($event, 'value25', 'tek_value25')"
              @blur="handleBlur($event)"
              type="text"
              v-model="selectShablonJson.value25"
            ></input>
          </div>
          <div class="display-flex">
            <label>Dori darmon va oziq ovqatlarga allergiyasi:</label>
            <div
              @click="selectKey('tek_value26'), (row_click_type = {type: true, value: 'value26'})"
              style="width: 450px"
            >
              <v-select
                style="width: 100%;"
                :options="itemShablon"
                ref="doriselect"
                label="name"
                v-model="selectShablonJson.value26"
                @search="ValueSel"
                @input="textChange"
                :reduce="options => options.name"
                @keydown.native="setStatus($event)"
              >
                <template #search="{ attributes, events }">
                  <input class="vs__search" v-bind="attributes" v-on="events" />
                  <button
                    v-if="!selectShablonJson.value26"
                    class="btn-select"
                    v-b-modal="'shablon-select-karta' + index + modalIdCom"
                  >
                    ...
                  </button>
                </template>
                <template
                  v-slot:no-options="{
                    search,
                    searching
                  }"
                >
                  <template v-if="searching">
                    <em
                      ><b>{{ search }}</b></em
                    >{{ "бўйича маьлумот йўқ" }}
                    <div class="d-flex-center">
                      <b-button
                        class="insertbtn"
                        variant="success"
                        @click="setStatus(45)"
                        v-b-modal="'modal-shab-select-create-karta-doc' + index + modalIdCom"
                      >
                        <b-icon icon="plus" color="#fff"></b-icon>
                      </b-button>
                    </div>
                    <b> Insert</b>
                  </template>
                  <em style="opacity: 0.5;" v-else>{{ "Маьлумот йўқ" }}</em>
                </template>
              </v-select>
            </div>
          </div>
          <div class="display-flex">
            <label>Oxirgi 1 oy ichida tana harorati ko'tarilganmi:</label>
            <div
              @click="selectKey('tek_value27'), (row_click_type = {type: true, value: 'value27'})"
              style="width: 500px"
            >
              <v-select
                style="width: 100%;"
                :options="itemShablon"
                ref="doriselect"
                label="name"
                v-model="selectShablonJson.value27"
                @search="ValueSel"
                @input="textChange"
                :reduce="options => options.name"
                @keydown.native="setStatus($event)"
              >
                <template #search="{ attributes, events }">
                  <input class="vs__search" v-bind="attributes" v-on="events" />
                  <button
                    v-if="!selectShablonJson.value27"
                    class="btn-select"
                    v-b-modal="'shablon-select-karta' + index + modalIdCom"
                  >
                    ...
                  </button>
                </template>
                <template
                  v-slot:no-options="{
                    search,
                    searching
                  }"
                >
                  <template v-if="searching">
                    <em
                      ><b>{{ search }}</b></em
                    >{{ "бўйича маьлумот йўқ" }}
                    <div class="d-flex-center">
                      <b-button
                        class="insertbtn"
                        variant="success"
                        @click="setStatus(45)"
                        v-b-modal="'modal-shab-select-create-karta-doc' + index + modalIdCom"
                      >
                        <b-icon icon="plus" color="#fff"></b-icon>
                      </b-button>
                    </div>
                    <b> Insert</b>
                  </template>
                  <em style="opacity: 0.5;" v-else>{{ "Маьлумот йўқ" }}</em>
                </template>
              </v-select>
            </div>
          </div>
        </div>
  
        <div class="stat-bemor-text">
          <h3 class="sarlovha-style">Umumiy ahvoli (Status preasets objektivus)</h3>
          <label>Umumiy axvoli</label>
          <!-- <b-button
            variant="primary"
            class="navbarBtnTashxis mb-3 mr-2"
            v-b-modal="'modal-shablon' + 'shifokor_tash' + index + modalIdCom"
            @click="getShablonDoctor('karta_value28', {type: true, value: 'value28'})"
          >
            <b-icon icon="arrow-down-circle-fill"></b-icon>
          </b-button>
  
          <b-button
            variant="primary"
            class="navbarBtnTashxis mb-3"
            @click="status = 'karta_value28', row_click_type =  { type: true, value: 'value28'}"
            v-b-modal="'modal-new-shab-creat-shifokor_tash' + index + modalIdCom"
          >
            <b-icon icon="arrow-up-circle-fill"></b-icon>
          </b-button> -->
          <input 
            class="input-stile mb-2" 
            style="width: 500px;" 
            @input="textChange" 
            @focus="showDiv($event, 'value28', 'karta_value28')"
            @blur="handleBlur($event)"
            type="text"
            v-model="selectShablonJson.value28"
          ></input>
          <br>
          <label>Tana harorati</label>
          <input
            class="input-stile" 
            type="text"
            @input="textChange"
            style="width: 80px;"
            v-model="selectShablonJson.value29"
          />
          <label>Bo'yi(cm)</label>
          <input
            class="input-stile" 
            type="text"
            @input="textChange"
            style="width: 80px;"
            v-model="selectShablonJson.value30"
          />
          <label>Vazni(kg)</label>
          <input
            class="input-stile" 
            type="text"
            @input="textChange"
            style="width: 80px;"
            v-model="selectShablonJson.value31"
          />
          <label>Tana vazni indexsi (kg/cm^2)</label>
          <input
            class="input-stile" 
            type="text"
            @input="textChange"
            style="width: 80px;"
            v-model="selectShablonJson.value32"
          />
          <div class="display-flex">
            <label>Teri va qornidagi shilliq qavatlarning holati</label>
            <input 
              class="input-stile mb-2" 
              style="width: 500px;" 
              @input="textChange" 
              @focus="showDiv($event, 'value34', 'tek_value34')"
              @blur="handleBlur($event)"
              type="text"
              v-model="selectShablonJson.value34"
            ></input>
          </div>
  
          <div class="display-flex">
            <label>Suyak-mushak tizimi:</label>
            <div
              @click="selectKey('tek_value37'), (row_click_type = {type: true, value: 'value37'})"
              style="width: 500px; margin-top: 5px;"
            >
              <v-select
                style="width: 100%;"
                :options="itemShablon"
                ref="doriselect"
                label="name"
                v-model="selectShablonJson.value37"
                @search="ValueSel"
                @input="textChange"
                :reduce="options => options.name"
                @keydown.native="setStatus($event)"
              >
                <template #search="{ attributes, events }">
                  <input class="vs__search" v-bind="attributes" v-on="events" />
                  <button
                    v-if="!selectShablonJson.value37"
                    class="btn-select"
                    v-b-modal="'shablon-select-karta' + index + modalIdCom"
                  >
                    ...
                  </button>
                </template>
                <template
                  v-slot:no-options="{
                    search,
                    searching
                  }"
                >
                  <template v-if="searching">
                    <em
                      ><b>{{ search }}</b></em
                    >{{ "бўйича маьлумот йўқ" }}
                    <div class="d-flex-center">
                      <b-button
                        class="insertbtn"
                        variant="success"
                        @click="setStatus(45)"
                        v-b-modal="'modal-shab-select-create-karta-doc' + index + modalIdCom"
                      >
                        <b-icon icon="plus" color="#fff"></b-icon>
                      </b-button>
                    </div>
                    <b> Insert</b>
                  </template>
                  <em style="opacity: 0.5;" v-else>{{ "Маьлумот йўқ" }}</em>
                </template>
              </v-select>
            </div>
          </div>
  
          <div class="display-flex">
            <label>Periferik limfa tugunlari holati:</label>
            <div
              @click="selectKey('tek_value38'), (row_click_type = {type: true, value: 'value38'})"
              style="width: 500px; margin-top: 5px;"
            >
              <v-select
                style="width: 100%;"
                :options="itemShablon"
                ref="doriselect"
                label="name"
                v-model="selectShablonJson.value38"
                @search="ValueSel"
                @input="textChange"
                :reduce="options => options.name"
                @keydown.native="setStatus($event)"
              >
                <template #search="{ attributes, events }">
                  <input class="vs__search" v-bind="attributes" v-on="events" />
                  <button
                    v-if="!selectShablonJson.value38"
                    class="btn-select"
                    v-b-modal="'shablon-select-karta' + index + modalIdCom"
                  >
                    ...
                  </button>
                </template>
                <template
                  v-slot:no-options="{
                    search,
                    searching
                  }"
                >
                  <template v-if="searching">
                    <em
                      ><b>{{ search }}</b></em
                    >{{ "бўйича маьлумот йўқ" }}
                    <div class="d-flex-center">
                      <b-button
                        class="insertbtn"
                        variant="success"
                        @click="setStatus(45)"
                        v-b-modal="'modal-shab-select-create-karta-doc' + index + modalIdCom"
                      >
                        <b-icon icon="plus" color="#fff"></b-icon>
                      </b-button>
                    </div>
                    <b> Insert</b>
                  </template>
                  <em style="opacity: 0.5;" v-else>{{ "Маьлумот йўқ" }}</em>
                </template>
              </v-select>
            </div>
          </div>

          <div class="display-flex">
            <label>Oyoqlarda shish bor,</label>
            <div
              @click="selectKey('tek_value36'), (row_click_type = {type: true, value: 'value36'})"
              style="width: 500px; margin-top: 5px;"
            >
              <v-select
                style="width: 100%;"
                :options="itemShablon"
                ref="doriselect"
                label="name"
                v-model="selectShablonJson.value36"
                @search="ValueSel"
                @input="textChange"
                :reduce="options => options.name"
                @keydown.native="setStatus($event)"
              >
                <template #search="{ attributes, events }">
                  <input class="vs__search" v-bind="attributes" v-on="events" />
                  <button
                    v-if="!selectShablonJson.value36"
                    class="btn-select"
                    v-b-modal="'shablon-select-karta' + index + modalIdCom"
                  >
                    ...
                  </button>
                </template>
                <template
                  v-slot:no-options="{
                    search,
                    searching
                  }"
                >
                  <template v-if="searching">
                    <em
                      ><b>{{ search }}</b></em
                    >{{ "бўйича маьлумот йўқ" }}
                    <div class="d-flex-center">
                      <b-button
                        class="insertbtn"
                        variant="success"
                        @click="setStatus(45)"
                        v-b-modal="'modal-shab-select-create-karta-doc' + index + modalIdCom"
                      >
                        <b-icon icon="plus" color="#fff"></b-icon>
                      </b-button>
                    </div>
                    <b> Insert</b>
                  </template>
                  <em style="opacity: 0.5;" v-else>{{ "Маьлумот йўқ" }}</em>
                </template>
              </v-select>
            </div>
          </div>

          <h3 class="sarlovha-style">Nafas olish tizimi</h3>
          <label>Nafas olish</label>
          <input
            class="input-stile" 
            type="text"
            @input="textChange"
            style="width: 150px;"
            v-model="selectShablonJson.value39"
          />
          <label>NOS</label>
          <input
            class="input-stile" 
            type="text"
            @input="textChange"
            style="width: 150px;"
            v-model="selectShablonJson.value40"
          />
          <label>minutiga</label>
          <br>
          <label>O'pkada</label>
          <input
            class="input-stile" 
            type="text"
            @input="textChange"
            @focus="showDiv($event, 'value41', 'karta_value41')"
            @blur="handleBlur($event)"
            style="width: 450px;"
            v-model="selectShablonJson.value41"
          />
          <div class="display-flex">
            <label>Ko'krak qafasi</label>
            <input
              class="input-stile" 
              type="text"
              @input="textChange"
              @focus="showDiv($event, 'value42', 'karta_value42')"
              @blur="handleBlur($event)"
              style="width: 500px;"
              v-model="selectShablonJson.value42"
            />
          </div>
          <h3 class="sarlovha-style">Yurak qon tomir tizimi</h3>
          <div>
            <label>Arterial qon bosimi (mm. cim. ust):</label>
            <input
              class="input-stile" 
              type="text"
              @input="textChange"
              @focus="showDiv($event, 'value75', 'karta_value75')"
              @blur="handleBlur($event)"
              style="width: 400px;"
              v-model="selectShablonJson.value75"
            />
          </div>

          <div>
            <label>Puls</label>
            <input
              class="input-stile" 
              type="text"
              @input="textChange"
              @focus="showDiv($event, 'value77', 'karta_value77')"
              @blur="handleBlur($event)"
              style="width: 500px;"
              v-model="selectShablonJson.value77"
            />
          </div>
          <div>
            <label>YUUS daqiqasiga</label>
            <input
              class="input-stile" 
              type="text"
              @input="textChange"
              @focus="showDiv($event, 'value78', 'karta_value78')"
              @blur="handleBlur($event)"
              style="width: 600px;"
              v-model="selectShablonJson.value78"
            />
          </div>
          <h3 class="sarlovha-style left">Perkussiya</h3>
          <label>Yurakning nisbiy bug'iqligi</label>
          <label>Chegarasi: chap - 5 qovurg'alar oralig'ida chap linea medioclavicularis dan 1-1,5 sm ichkarida</label>
          <input
              class="input-stile" 
              type="text"
              @input="textChange"
              @focus="showDiv($event, 'value91', 'karta_value91')"
              @blur="handleBlur($event)"
              style="width: 600px;"
              v-model="selectShablonJson.value91"
          />
            <label>O'ng qovurg'alar oralig'ida o'ng linea parastrenalis dan 0,5 sm tashqarida</label>
            <input
                class="input-stile" 
                type="text"
                @input="textChange"
                @focus="showDiv($event, 'value92', 'karta_value92')"
              @blur="handleBlur($event)"
                style="width: 600px;"
                v-model="selectShablonJson.value92"
            />
          <div class="display-flex">
            <label>Yuqori -chap 3-qovurg'alar oralig'ida</label>
            <input
                class="input-stile" 
                type="text"
                @input="textChange"
                @focus="showDiv($event, 'value93', 'karta_value93')"
                @blur="handleBlur($event)"
                style="width: 600px;"
                v-model="selectShablonJson.value93"
            />
          </div>
          <h3 class="sarlovha-style left">Auskultatsiya</h3>
          <div class="display-flex">
              <label>Yurak tovushlari bo'g'iqligi :</label>
              <input
                  class="input-stile" 
                  type="text"
                  @input="textChange"
                  @focus="showDiv($event, 'value86', 'tek_value86')"
                  @blur="handleBlur($event)"
                  style="width: 500px;"
                  v-model="selectShablonJson.value86"
              />
          </div>
          <label>Yurak shovqinlari</label>
          <input
            class="input-stile"
            @input="textChange"
            @focus="showDiv($event, 'value94', 'karta_value94')"
            @blur="handleBlur($event)"
            style="width: calc(100% - 150px)"
            v-model="selectShablonJson.value94"
          />
          <div class="display-flex">
              <label>Aortada II ton aksenti </label>
              <div
                      @click="selectKey('tek_value95'), (row_click_type = {type: true, value: 'value95'})"
                      style="width: 300px; margin-top: 5px;"
                    >
                      <v-select
                        style="width: 100%;"
                        :options="itemShablon"
                        ref="doriselect"
                        label="name"
                        v-model="selectShablonJson.value95"
                        @search="ValueSel"
                        @input="textChange"
                        :reduce="options => options.name"
                        @keydown.native="setStatus($event)"
                      >
                        <template #search="{ attributes, events }">
                          <input class="vs__search" v-bind="attributes" v-on="events" />
                          <button
                            v-if="!selectShablonJson.value95"
                            class="btn-select"
                            v-b-modal="'shablon-select-karta' + index + modalIdCom"
                          >
                            ...
                          </button>
                        </template>
                        <template
                          v-slot:no-options="{
                            search,
                            searching
                          }"
                        >
                          <template v-if="searching">
                            <em
                              ><b>{{ search }}</b></em
                            >{{ "бўйича маьлумот йўқ" }}
                            <div class="d-flex-center">
                              <b-button
                                class="insertbtn"
                                variant="success"
                                @click="setStatus(45)"
                                v-b-modal="'modal-shab-select-create-karta-doc' + index + modalIdCom"
                              >
                                <b-icon icon="plus" color="#fff"></b-icon>
                              </b-button>
                            </div>
                            <b> Insert</b>
                          </template>
                          <em style="opacity: 0.5;" v-else>{{ "Маьлумот йўқ" }}</em>
                        </template>
                      </v-select>
                    </div>
          </div>
          <h3 class="sarlovha-style">Hazm qilish tizimi</h3>
          <div class="display-flex">
            <div style="width: 50%;">
              <div class="display-flex">
                <label>Tili</label>
                <input
                  class="input-stile"
                  @input="textChange"
                  @focus="showDiv($event, 'value103', 'tek_value103')"
                  @blur="handleBlur($event)"
                  style="width: 250px;"
                  v-model="selectShablonJson.value103"
                />
              </div>
              <div class="display-flex">
                <label>Tamoq</label>
                <input
                  class="input-stile"
                  @input="textChange"
                  @focus="showDiv($event, 'value104', 'tek_value104')"
                  @blur="handleBlur($event)"
                  style="width: 250px;"
                  v-model="selectShablonJson.value104"
                />
              </div>
              <div class="display-flex">
                <label>Murtak bezlari</label>
                <div
                  @click="selectKey('tek_value105'), (row_click_type = {type: true, value: 'value105'})"
                  style="width: 250px; margin-top: 5px;"
                >
                  <v-select
                    style="width: 100%;"
                    :options="itemShablon"
                    ref="doriselect"
                    label="name"
                    v-model="selectShablonJson.value105"
                    @search="ValueSel"
                    @input="textChange"
                    :reduce="options => options.name"
                    @keydown.native="setStatus($event)"
                  >
                    <template #search="{ attributes, events }">
                      <input class="vs__search" v-bind="attributes" v-on="events" />
                      <button
                        v-if="!selectShablonJson.value105"
                        class="btn-select"
                        v-b-modal="'shablon-select-karta' + index + modalIdCom"
                      >
                        ...
                      </button>
                    </template>
                    <template
                      v-slot:no-options="{
                        search,
                        searching
                      }"
                    >
                      <template v-if="searching">
                        <em
                          ><b>{{ search }}</b></em
                        >{{ "бўйича маьлумот йўқ" }}
                        <div class="d-flex-center">
                          <b-button
                            class="insertbtn"
                            variant="success"
                            @click="setStatus(45)"
                            v-b-modal="'modal-shab-select-create-karta-doc' + index + modalIdCom"
                          >
                            <b-icon icon="plus" color="#fff"></b-icon>
                          </b-button>
                        </div>
                        <b> Insert</b>
                      </template>
                      <em style="opacity: 0.5;" v-else>{{ "Маьлумот йўқ" }}</em>
                    </template>
                  </v-select>
                </div>
              </div>
            </div>
  
            <div style="width: 50%;">
              <div class="display-flex">
                <label>Qorin</label>
                <input
                  class="input-stile"
                  @input="textChange"
                  @focus="showDiv($event, 'value106', 'tek_value106')"
                  @blur="handleBlur($event)"
                  style="width: 250px;"
                  v-model="selectShablonJson.value106"
                />
              </div>
              <div class="display-flex">
                <label>Taloq</label>
                <input
                  class="input-stile"
                  @input="textChange"
                  @focus="showDiv($event, 'value107', 'tek_value107')"
                  @blur="handleBlur($event)"
                  style="width: 250px;"
                  v-model="selectShablonJson.value107"
                />
              </div>
              <div class="display-flex">
                <label>Jigar</label>
                <input
                  class="input-stile" 
                  type="text"
                  @input="textChange"
                  @focus="showDiv($event, 'value112', 'karta_value112')"
                  @blur="handleBlur($event)"
                  style="width: 250px;"
                  v-model="selectShablonJson.value112"
                />
              </div>
            </div>
          </div>
          <div class="display-flex">
            <label>Qabziyat</label>
            <input
              class="input-stile" 
              type="text"
              @input="textChange"
              @focus="showDiv($event, 'value108', 'tek_value108')"
              @blur="handleBlur($event)"
              style="width: 400px;"
              v-model="selectShablonJson.value108"
            />
          </div>
        
  
          <h3 class="sarlovha-style">Siydik ajralish tizimi</h3>
          <div class="display-flex">
            <label>Diurez</label>
            <div
              @click="selectKey('tek_value113'), (row_click_type = {type: true, value: 'value113'})"
              style="width: 250px; margin-top: 5px;"
            >
              <v-select
                style="width: 100%;"
                :options="itemShablon"
                ref="doriselect"
                label="name"
                v-model="selectShablonJson.value113"
                @search="ValueSel"
                @input="textChange"
                :reduce="options => options.name"
                @keydown.native="setStatus($event)"
              >
                <template #search="{ attributes, events }">
                  <input class="vs__search" v-bind="attributes" v-on="events" />
                  <button
                    v-if="!selectShablonJson.value113"
                    class="btn-select"
                    v-b-modal="'shablon-select-karta' + index + modalIdCom"
                  >
                    ...
                  </button>
                </template>
                <template
                  v-slot:no-options="{
                    search,
                    searching
                  }"
                >
                  <template v-if="searching">
                    <em
                      ><b>{{ search }}</b></em
                    >{{ "бўйича маьлумот йўқ" }}
                    <div class="d-flex-center">
                      <b-button
                        class="insertbtn"
                        variant="success"
                        @click="setStatus(45)"
                        v-b-modal="'modal-shab-select-create-karta-doc' + index + modalIdCom"
                      >
                        <b-icon icon="plus" color="#fff"></b-icon>
                      </b-button>
                    </div>
                    <b> Insert</b>
                  </template>
                  <em style="opacity: 0.5;" v-else>{{ "Маьлумот йўқ" }}</em>
                </template>
              </v-select>
            </div>
          </div>
          <div class="display-flex">
            <label>Miqdori</label>
            <div
              @click="selectKey('tek_value114'), (row_click_type = {type: true, value: 'value114'})"
              style="width: 250px; margin-top: 5px;"
            >
              <v-select
                style="width: 100%;"
                :options="itemShablon"
                ref="doriselect"
                label="name"
                v-model="selectShablonJson.value114"
                @search="ValueSel"
                @input="textChange"
                :reduce="options => options.name"
                @keydown.native="setStatus($event)"
              >
                <template #search="{ attributes, events }">
                  <input class="vs__search" v-bind="attributes" v-on="events" />
                  <button
                    v-if="!selectShablonJson.value114"
                    class="btn-select"
                    v-b-modal="'shablon-select-karta' + index + modalIdCom"
                  >
                    ...
                  </button>
                </template>
                <template
                  v-slot:no-options="{
                    search,
                    searching
                  }"
                >
                  <template v-if="searching">
                    <em
                      ><b>{{ search }}</b></em
                    >{{ "бўйича маьлумот йўқ" }}
                    <div class="d-flex-center">
                      <b-button
                        class="insertbtn"
                        variant="success"
                        @click="setStatus(45)"
                        v-b-modal="'modal-shab-select-create-karta-doc' + index + modalIdCom"
                      >
                        <b-icon icon="plus" color="#fff"></b-icon>
                      </b-button>
                    </div>
                    <b> Insert</b>
                  </template>
                  <em style="opacity: 0.5;" v-else>{{ "Маьлумот йўқ" }}</em>
                </template>
              </v-select>
            </div>
          </div>
          <div class="display-flex">
            <label>Turtki belgisi</label>
            <input
              class="input-stile" 
              type="text"
              @input="textChange"
              @focus="showDiv($event, 'value115', 'tek_value115')"
              @blur="handleBlur($event)"
              style="width: 600px;"
              v-model="selectShablonJson.value115"
            />
          </div>
          <input
            class="input-stile" 
            type="text"
            @input="textChange"
            @focus="showDiv($event, 'value116', 'karta_value116')"
              @blur="handleBlur($event)"
            style="width: 600px;"
            v-model="selectShablonJson.value116"
        />
        </div>
      </div>
      <div style="display: flex; justify-content: space-between;">
        <div class="stat-bemor-text">
            <label>EKG xulosasi</label>
            <b-button
            variant="primary"
            class="navbarBtnTashxis mb-3 mr-2"
            v-b-modal="'modal-shablon' + 'shifokor_tash' + index + modalIdCom"
            @click="getShablonDoctor('karta_value17', {type: true, value: 'value17'})"
          >
            <b-icon icon="arrow-down-circle-fill"></b-icon>
          </b-button>
  
          <b-button
            variant="primary"
            class="navbarBtnTashxis mb-3"
            @click="status = 'karta_value17', row_click_type =  { type: true, value: 'value17'}"
            v-b-modal="'modal-new-shab-creat-shifokor_tash' + index + modalIdCom"
          >
            <b-icon icon="arrow-up-circle-fill"></b-icon>
          </b-button>
            <textarea 
                rows="3"
                v-model="selectShablonJson.value17"
                class="input-stile-textarea"
                @input="textChange"
                style="width: 100%;"
            ></textarea>
            <label>Bemorning shikoyati, kasallik tarixi xayot tarzi, umumiy ahvoli, va obyektiv tekshiruvlar asosidagi </label> <br>
            <label>Tashxis</label>
            <b-button
              variant="primary"
              class="navbarBtnTashxis mb-3 mr-2"
              v-b-modal="'modal-shablon' + 'shifokor_tash' + index + modalIdCom"
              @click="getShablonDoctor('karta_value21', {type: true, value: 'value21'})"
            >
              <b-icon icon="arrow-down-circle-fill"></b-icon>
            </b-button>
    
            <b-button
              variant="primary"
              class="navbarBtnTashxis mb-3"
              @click="status = 'karta_value21', row_click_type =  { type: true, value: 'value21'}"
              v-b-modal="'modal-new-shab-creat-shifokor_tash' + index + modalIdCom"
            >
              <b-icon icon="arrow-up-circle-fill"></b-icon>
            </b-button>
            <textarea 
                rows="7"
                v-model="selectShablonJson.value21"
                class="input-stile-textarea"
                @input="textChange"
                style="width: 100%;"
            ></textarea>
        </div>
        <div class="stat-bemor-text">
            <label>Tavsiya etilgan tekshirishlar va konsultatsiyalarning natijalari:</label>
            <b-button
              variant="primary"
              class="navbarBtnTashxis mb-3 mr-2"
              v-b-modal="'modal-shablon' + 'shifokor_tash' + index + modalIdCom"
              @click="getShablonDoctor('karta_value76', {type: true, value: 'value76'})"
            >
              <b-icon icon="arrow-down-circle-fill"></b-icon>
            </b-button>
    
            <b-button
              variant="primary"
              class="navbarBtnTashxis mb-3"
              @click="status = 'karta_value76', row_click_type =  { type: true, value: 'value76'}"
              v-b-modal="'modal-new-shab-creat-shifokor_tash' + index + modalIdCom"
            >
              <b-icon icon="arrow-up-circle-fill"></b-icon>
            </b-button>
            <textarea 
                rows="5"
                v-model="selectShablonJson.value76"
                class="input-stile-textarea"
                @input="textChange"
                style="width: 100%;"
            ></textarea>
            <label>Tavsiyalar</label>
            <b-button
              variant="primary"
              class="navbarBtnTashxis mb-3 mr-2"
              v-b-modal="'modal-shablon' + 'shifokor_tash' + index + modalIdCom"
              @click="getShablonDoctor('karta_value3', {type: true, value: 'value33'})"
            >
              <b-icon icon="arrow-down-circle-fill"></b-icon>
            </b-button>
    
            <b-button
              variant="primary"
              class="navbarBtnTashxis mb-3"
              @click="status = 'karta_value33', row_click_type =  { type: true, value: 'value33'}"
              v-b-modal="'modal-new-shab-creat-shifokor_tash' + index + modalIdCom"
            >
              <b-icon icon="arrow-up-circle-fill"></b-icon>
            </b-button>
            <textarea 
                rows="6"
                v-model="selectShablonJson.value33"
                @input="textChange"
                class="input-stile-textarea"
                style="width: 100%;"
            ></textarea>
        </div>
      </div>
      <div
        :style="{
          top: divPosition.top + 'px',
          left: divPosition.left + 'px',
          width: divPosition.width + 'px',
          display: show ? 'block' : 'none'
        }"
        class="dynamic-div-karta"
      >
        <div
          v-for="item in itemShablon"
          class="drop-down"
          @click="selectItemValue(item.name)"
        >
          {{ item.name }}
          <div class="display-flex">
            <b-button
              v-b-modal="'modal-shab-select-create-karta-doc' + index + modalIdCom"
              variant="outline-primary"
              style="width: 30px; height: 30px"
              @click="userLink(row.item)"
              class="pencil"
            >
              <b-icon
                style="width: 10px;"
                variant="outline-primary"
                icon="pencil-fill"
                aria-hidden="true"
              ></b-icon>
            </b-button>
            <b-button
              class="trash ml-2"
              style="width: 30px; height: 30px"
              variant="outline-danger"
              @click="trash(row.item.id)"
            >
              <b-icon
                style="width: 10px;"
                icon="trash-fill"
                aria-hidden="true"
              ></b-icon>
            </b-button>
          </div>
        </div>
        <b-button
          class="insertbtn"
          style="align-items: center; text-align: center;"
          variant="success"
          @click="setStatus(45)"
          v-b-modal="'modal-shab-select-create-karta-doc' + index + modalIdCom"
        >
          <b-icon icon="plus" color="#fff"></b-icon>
        </b-button>
      </div>
      <b-modal
        :id="'shablon-select-karta' + index + modalIdCom"
        size="xl"
        hide-footer
      >
        <div style="display: flex; justify-content: space-between;">
          <button
            class="navbarBtnTashxis mb-2"
            v-b-modal="'modal-shab-select-create-karta-doc' + index + modalIdCom"
            @click="plusClick"
          >
            <b-icon icon="plus-lg"></b-icon>
          </button>
  
          <b-form-group
            label-for="filterTekshiruvlar-input"
            label-cols-sm="1"
            label-align-sm="right"
            label-size="sm"
            class="mb-2 col-8"
          >
            <b-input-group size="sm">
              <b-form-input
                id="filterTekshiruvlar-input"
                v-model="filter"
                type="search"
                :placeholder="$t('Қидирув')"
              ></b-form-input>
  
              <b-input-group-append>
                <b-button
                  :disabled="!filter"
                  variant="danger"
                  @click="filter = ''"
                >
                  {{ $t("Тозалаш") }}</b-button
                >
              </b-input-group-append>
            </b-input-group>
          </b-form-group>
        </div>
        <div>
          <b-table
            id="bemor-table"
            ref="refTable"
            hover
            sort-icon-left
            striped
            primary-key="id"
            :items="itemShablon"
            :fields="fields"
            :filter="filter"
            :current-page="currentPage"
            :filter-included-fields="filterOn"
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            :sort-direction="sortDirection"
            @row-clicked="RowClickedShab($event, null, true)"
            stacked="md"
            show-empty
            small
            @filtered="onFiltered"
          >
            <template #cell(№)="data">
              {{ data.index + 1 }}
            </template>
            <template #cell(actions)="row">
              <b-row class="ml-1">
                <section
                  style="display: flex; justify-content: flex-end; width: 100%; margin-right: 30px"
                >
                  <div style="display: flex;">
                    <b-button
                      v-b-modal="'modal-shab-select-create-karta-doc' + index + modalIdCom"
                      variant="outline-primary"
                      @click="userLink(row.item)"
                      class="pencil"
                    >
                      <b-icon
                        style="width: 15px;"
                        variant="outline-primary"
                        icon="pencil-fill"
                        aria-hidden="true"
                      ></b-icon>
                    </b-button>
                    <div>
                      <b-button
                        class="trash ml-2"
                        style=""
                        variant="outline-danger"
                        @click="trash(row.item.id)"
                      >
                        <b-icon
                          style="width: 15px;"
                          icon="trash-fill"
                          aria-hidden="true"
                        ></b-icon>
                      </b-button>
                    </div>
                  </div>
                </section>
              </b-row>
            </template>
          </b-table>
        </div>
      </b-modal>
      <b-modal
        :id="'modal-shab-select-create-karta-doc' + index + modalIdCom"
        :title="$t('Шифокор шаблон')"
        size="lg"
        hide-footer
      >
        <div>
          <b-input
            type="text"
            style="border: 1px solid #ccc; border-radius: 5px;"
            v-model="datas.name"
          >
          </b-input>
        </div>
        <div class="CreateName">
          <b-button
            class="modalBtn1"
            size="sm"
            style="height: 37px;"
            variant="danger "
            @click="Close()"
          >
            <b-icon icon="calendar2-x"></b-icon>
            {{ $t("Бекор қилиш") }}
          </b-button>
          <b-button
            class="mt-3 ml-2 modalBtn"
            @click="Shablon()"
            variant="success"
          >
            <b-icon icon="calendar2-plus"></b-icon>
            {{ $t("Сақлаш") }}
          </b-button>
        </div>
      </b-modal>
    </div>
  </template>
  
  <script>
  import Shablon from '../Shifokor/Shablon.vue';
  export default {
    props: ["statsionar_text", "modalIdCom", 'index'],
    components: {
      Shablon
    },
    data() {
      return {
        options: [],
        name: '',
        itemsShablon: [],
        show: false,
        row_click_type: {
          type: false,
          value: ""
        },
        datas: {
          id: 0,
          name: "",
          status: ""
        },
        divPosition: {
          top: 0,
          left: 0,
          with: 0
        },
        selectShablonJson: {},
        itemShablon: [],
        status: "",
        ValueSelect: "",
        fields: [
          "№",
          { key: "name", label: "Номи", sortable: true },
          { key: "actions", label: "" }
        ],
        totalRows: 1,
        currentPage: 1,
        sortBy: "",
        sortDesc: false,
        sortDirection: "asc",
        filter: null,
        filterOn: ["name"]
      };
    },
    created() {
      if (this.statsionar_text == "" || !this.statsionar_text) {
        this.selectShablonJson = {
          value1: null,
          value2: null,
          value3: null,
          value4: null,
          value5: null,
          value6: null,
          value7: null,
          value8: null,
          value9: null,
          value10: null,
          value11: null,
          value12: null,
          value13: null,
          value14: null,
          value15: null,
          value16: null,
          value17: null,
          
          
          value20: null,
          value21: null,
          value22: null,
          value23: null,
          value24: null,
          value25: null,
          value26: null,
          value27: null,
          value28: null,
          value29: null,
          value30: null,
          value31: null,
          value32: null,
          value33: null,
          value34: null,
          value35: null,
          value36: null,
          value37: null,
          value38: null,
          value39: null,
          value40: null,
          value41: null,
          value42: null,
          value43: null,
          value44: null,
          value45: null,
          value46: null,
          value47: null,
          value48: null,
          value49: null,
          value75: null,
          value76: null,
          value77: null,
          value78: null,
          value79: null,

          value86: null,
          
          value91: null,
          value92: null,
          value93: null,
          value94: null,
          value95: null,
          
          value103: null,
          value104: null,
          value105: null,
          value106: null,
          value107: null,
          value108: null,
          
          value110: null,
          value112: null,
          value113: null,
          value114: null,
          value115: null,
          value116: null
        };
      } else {
        this.selectShablonJson = JSON.parse(this.statsionar_text.toString());
      }
    },
    watch: {
      statsionar_text(newVal, old){
        this.selectShablonJson = JSON.parse(newVal.toString())
      }
    },
    methods: {
      RowClicked(data, index){

      },
      selectItemValue(value) {
        if (this.selectShablonJson[`${this.row_click_type.value}`] == null) {
          this.selectShablonJson[`${this.row_click_type.value}`] = value;
        } else {
          this.selectShablonJson[`${this.row_click_type.value}`] += ` ${value}`;
        }
        setTimeout(() => {
          this.show = false;
        }, 200);
        this.textChange();
      },
      showDiv(event, value, status) {
        this.row_click_type.value = value;
        this.status = status;
        this.getShablon(status);
        const input = event.target;
        const rect = input.getBoundingClientRect();
        this.divPosition.top = rect.top + window.pageYOffset + rect.height - 800;
        this.divPosition.left = rect.left + window.pageXOffset - 47;
        this.divPosition.width = rect.width;
        setTimeout(() => {
          this.handleBlur("", true);
        }, 200);
      },
      handleBlur(event, type) {
        if (!type) {
          setTimeout(() => {
            this.show = false;
          }, 100);
        } else {
          this.show = true;
        }
      },
      ShifokorShablonClose(){
        this.name = ''
        this.$bvModal.hide(`${'modal-new-shab-creat-shifokor_tash'  + this.index + this.modalIdCom}`);
      },
      RowClickedShab($events, ind, type) {
        if (this.row_click_type.type) {
          this.selectShablonJson[`${this.row_click_type.value}`] = type ? $events.name : $events.text;
        } else {
          let text = JSON.parse($events.text.toString());
          this.selectShablonJson = text;
        }
        this.$bvModal.hide(
          `${"modal-shablon" + "shifokor_tash" + this.index + this.modalIdCom}`
        );
        this.$bvModal.hide('shablon-select-karta' + this.index + this.modalIdCom)
      },
      getShablonDoctor(stat, value) {
        let self = this;
        self.row_click_type = value
        axios({
          method: "post",
          url: "/shablon_doctor/shablonOne",
          data: { 
            doctor_id: JSON.parse(localStorage.getItem("user")).id,
            doc_type: stat
          }
        }).then(res => {
          if (res) {
            self.itemsShablon = res.data.data;
          }
        });
      },
      ShifokorShablon(){
        let self = this
        let text = "";
        if (self.row_click_type.type) {
          text = self.selectShablonJson[self.row_click_type.value];
        } else {
          text = JSON.stringify(self.selectShablonJson).toString();
        }
        axios({
            method: "post",
            url: "/shablon_doctor/create",
            data: {
              name: self.name,
              text: text,
              doctor_id: JSON.parse(localStorage.getItem("user")).id,
              doc_type: self.status ? self.status : "shifokor_tash"
            }
          }).then(res => {
            if (res) {
              self.$bvModal.hide(`${'modal-new-shab-creat-shifokor_tash' + self.index + self.modalIdCom}`);
            }
          });
      },
      textChange() {
        this.$emit(
          "statsionar_text_change",
          JSON.stringify(this.selectShablonJson).toString(), 'shifokor_tash', this.index
        );
      },
      plusClick() {
        this.datas = {
          id: 0,
          name: "",
          status: ""
        };
      },
      setStatus($events) {
        if ($events.keyCode == 45 || $events == 45) {
          this.datas = {
            name: this.ValueSelect,
            status: this.status
          };
          this.$bvModal.show("modal-shab-select-create-karta-doc" + this.index + this.modalIdCom);
        }
      },
      selectKey(key) {
        this.status = key;
        this.getShablon(key);
      },
      getShablon(status) {
        let self = this;
        axios({
          method: "post",
          url: "/shablon_select/shablonOne",
          data: { status: status }
        }).then(res => {
          if (res) {
            self.itemShablon = res.data.data;
          }
        });
      },
      userLink(item) {
        this.datas = item;
        this.$bvModal.show("modal-shab-select-create-karta-doc" + this.index + this.modalIdCom);
      },
      trash(id) {
        let self = this;
        axios({
          method: "delete",
          url: "/shablon_select/delete/" + id
        }).then(res => {
          if (res) {
            self.getShablon(self.status);
            // self.$bvModal.hide('modal-shab-select-create-karta-doc' + index + self.index + self.modalIdCom);
          }
        });
      },
      ValueSelChange() {
        let value = JSON.stringify(this.statsionar_text);
        // console.log(this.statsionar_text, value);
        this.$emit("selectSablon", value, this.index);
        // this.shablonData = JSON.stringify(this.statsionar_text)
      },
      ValueSel(e) {
        this.ValueSelect = e;
        // salommmmmmmm
      },
      Shablon() {
        let self = this;
        let method = "";
        let url = "";
        if (this.datas.id) {
          method = "patch";
          url = "/shablon_select/update/" + self.datas.id;
        } else {
          self.datas.status = self.status;
          method = "post";
          url = "/shablon_select/create";
        }
        axios({
          method: method,
          url: url,
          data: self.datas
        }).then(res => {
          if (res) {
            self.getShablon(self.status);
            self.$bvModal.hide("modal-shab-select-create-karta-doc" + this.index + self.modalIdCom);
            self.datas = {
              id: 0,
              name: "",
              status: ""
            };
          }
        });
      },
      Close() {
        datas = {
          id: 0,
          name: "",
          status: ""
        };
      },
      onFiltered(filtered) {
        this.totalRows = filtered.length;
        this.currentPage = 1;
      }
    }
  };
  </script>
  
  <style lang="scss">
  .dynamic-div-karta {
    min-width: 150px;
    position: absolute;
    background-color: #fff;
    border: 1px solid #ccc;
    z-index: 10;
    cursor: pointer;
    display: none;
    .drop-down {
      cursor: pointer;
      align-items: center;
      height: 35px;
      display: flex;
      justify-content: space-between;
      padding-left: 5px;
      font-size: 13pt;
    }
  }
.drop-down:hover {
  background: rgb(46, 165, 255);
  color: #fff;
}
  .vueTextEditor .ql-editor{
    p{
      font-size: 13pt;
      font-weight: 500;
    }
  }
  .izoh-style{
    font-size: 9pt;
    margin-top: -3px;
    text-align: center;
    font-family: 'Times New Roman', Times, serif;
  }
  .sarlovha{
    font-family: 'Times New Roman';
    font-size: 14pt;
    font-weight: 600;
    font-style: oblique;
  }
  .sarlovha-style{
    margin-top: 10px;
    text-align: center;
    font-family: 'Times New Roman';
  }
  .left{
    text-align: left;
  }
  .stat-bemor-text {
    margin-bottom: 10px;
    width: 49.5%;
    padding: 10px;
    border: 1px solid rgb(46, 165, 255);
    border-radius: 10px;
    label {
      font-family: 'Times New Roman', Times, serif;
      margin-top: 5px;
      font-size: 13pt;
      font-weight: 500;
      margin-right: 5px;
    }
  }
  .input-stile {
    border-top: none;
    border-left: none;
    border-right: none;
    font-family: 'Times New Roman', Times, serif;
    font-size: 13pt;
    font-weight: 500;
    margin-right: 5px;
    border-bottom: 1px solid #000;
  }
  .input-stile-textarea{
    margin-top: 5px;
    font-family: 'Times New Roman', Times, serif;
    font-size: 13pt;
    font-weight: 500;
    margin-right: 5px;
    border-bottom: 1px solid #000;
  }
  .display-flex {
    display: flex;
  }
  .btn-select {
    background-color: #fff0;
    // border: none;
    // border: 1px  solid #000;
    // border-radius: 50%;
    font-size: 14pt;
    font-weight: 700;
    height: 27px;
    width: 27px;
    cursor: pointer;
    z-index: 2;
    position: absolute;
    top: calc(50% - 13px);
    right: 0px;
    color: #6c6868;
    /* left: -50px; */
  }
  </style>
  